import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { Router } from "react-router-dom";
import { Utils } from "./config";
import { Provider } from "react-redux";
import Store from "./store";
import { BrowserRouter as Router } from "react-router-dom";
import "antd/dist/antd.css";
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,  // no auto refetch on tab focus
    }
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <Router basename="/">
    <Provider store={Store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
